<script>

    import { SendRequest, ReleaseMode } from "./APIService";
    import { showModal } from "./Modal";
    import moment from 'moment';

    let searchClanName = "";

    let newClanName = "";
    let newClanDescription = "";

    let keys = [];
    let values = [];


    let ClanData = {
    };

    let bestClansItems = [];
    let tournamentDetails = {};
    let bestClanIndex = [];
    let bestClanNames = [];
    let bestClanIds = [];
    let bestClanScores = [];

    $: {
    keys = [];
    values = [];
        for (const [key, value] of Object.entries(ClanData)) {
            keys = [...keys, key];
            values = [...values, value];
            console.log(`${key}: ${value}`);
        }
    }

    $: {
        bestClanIndex = [];
        bestClanNames = [];
        bestClanIds = [];
        bestClanScores = [];
        for (let i = 0; i < bestClansItems.length; i++){
            bestClanIndex = [...bestClanIndex, bestClansItems[i].rank];
            bestClanNames = [...bestClanNames, bestClansItems[i].clanName];
            bestClanIds = [...bestClanIds, bestClansItems[i].clanId];
            bestClanScores = [...bestClanScores, bestClansItems[i].score]
        }
    }

    let tournamentDetailsKeys = [];
    let tournamentDetailsValues = [];

    $: {
        tournamentDetailsKeys = [];
        tournamentDetailsValues = [];
        for (const [key, value] of Object.entries(tournamentDetails)) {
            tournamentDetailsKeys = [...tournamentDetailsKeys, key];
            tournamentDetailsValues = [...tournamentDetailsValues, value];
            console.log(`${key}: ${value}`);
        }
    }


    function SearchClans() {
        SendRequest(
            "GetClanByName",
            "POST",
            "clanName=" + searchClanName,
            (response) => {
                console.log("Search clan Called");
                delete response.activeItemRequests;
                ClanData = response;
            },
            (error) => {
                showModal("Error", "Clan not found", "OK");
                ClanData = {};
            }
        );
    }

    function GetBestClansOfLastTournament(){
        SendRequest(
            "LatestClanTournamentWinners",
            "GET",
            "",
            (response) => {
                console.log("get best clan Called");
                bestClansItems = response.leaderboardItems;
                tournamentDetails = response.tournamentDetails;
                tournamentDetails.startTime = moment(new Date(tournamentDetails.startTime)).from(new Date());
                tournamentDetails.endTime = moment(new Date(tournamentDetails.endTime)).from(new Date());
                delete tournamentDetails.anounceAt;
                delete tournamentDetails.options;
                delete tournamentDetails.eventType;
            },
            (error) => {
                showModal("Error", "could not get best clans", "OK");
                bestClansItems = [];
            }
        );
    }

    function UpdateClan(){
        SendRequest(
            "RenameClan",
            "POST",
            "clanId=" + ClanData.id + "&newClanName=" + newClanName + "&newDescription=" + newClanDescription,
            (response) => {
                console.log("clan renamed successfully");
                showModal("Success", "clan renamed successfully", "OK");
                delete response.activeItemRequests;
                ClanData = response;
            },
            (error) => {
                showModal("Error", error, "OK");
            }
        );
    }


    function onKeyDown(e){
        if (searchClanName == "") {
            return;
        }
        switch(e.keyCode) {
            case 13:
                SearchClans()
                break;
        }
    }

</script>

<br />
<br />
<br />

<div class="container">

    <div class="row justify-content-md-center">
        <div class="card col-md-8">
            <div class="card-header" style="text-align: center;">
                <h2>Clan</h2>
            </div>
            <ul class="nav nav-pills nav-fill nav-justified" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active" id="search-tab" data-bs-toggle="tab" data-bs-target="#search" type="button"
                            role="tab" aria-controls="search" aria-selected="true">Search</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" id="leaderboard-tab" data-bs-toggle="tab" data-bs-target="#leaderboard"
                            type="button" role="tab" aria-controls="leaderboard" aria-selected="false">Clan Tournament</button>
                </li>
            </ul>
        </div>
    </div>

    <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="search" role="tabpanel" aria-labelledby="search-tab">
            <hr>
            <!-- Search clans -->
            <div class="row justify-content-md-center">
                <div class="card col-md-8">
                    <h5 class="card-header" style="text-align: center;">
                        <h3>Find Clan</h3>
                    </h5>

                    <div class="card-body">
                        <div class="mb-3 row">
                            <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Clan Name"
                                    bind:value={searchClanName}
                            />
                        </div>
                        <div class="mb-3 row">
                            <button
                                    class="btn btn-danger"
                                    type="button"
                                    on:click={SearchClans}>Search</button
                            >
                        </div>
                    </div>
                </div>
            </div>

            {#if keys.length > 0}
                <hr>
                <div class="row justify-content-md-center">

                    <div class="card col-md-8">
                        <h5 class="card-header" style="text-align: center;"><h3>Tools</h3></h5>

                        <div class="card-body">

                            <div class="mb-3 row">
                                <label  class="form-label">NewName</label>
                                <input type="text" class="form-control" placeholder="Name" bind:value={newClanName}>
                            </div>
                            <div class="mb-3 row">
                                <label  class="form-label">New Description</label>
                                <input type="text" class="form-control" placeholder="Description" bind:value={newClanDescription}>
                            </div>

                            <div class="mb-3 row">
                                <button class="btn btn-danger" type="button" on:click={UpdateClan}>Update</button>
                            </div>



                        </div>
                    </div>
                    <hr>
                    <div class="card col-md-8">
                        <div class="card-header" style="text-align: center;">
                            <h3>Clan Data</h3>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered table-hover">
                                <!-- <thead>
                                    <tr>
                                        <th scope="col">Item</th>
                                        <th scope="col">Value</th>
                                    </tr>
                                </thead> -->
                                <tbody>
                                {#each keys as prop, index}
                                    <tr>
                                        {#if prop == "clan_TeamMembers"}
                                            <td>Clan Members</td>
                                            <td>
                                                <!-- create a new table here -->
                                                <table class="table table-bordered table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">userId</th>
                                                        <th scope="col">positionInClan</th>
                                                        <th scope="col">joinedAt</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {#each values[index] as prop2, index2}
                                                        <tr>
                                                            <!-- <th scope="row">1</th> -->
                                                            <td>{prop2.userId}</td>
                                                            {#if prop2.positionInClan == 0}
                                                                <td>Owner</td>
                                                            {:else if prop2.positionInClan == 1}
                                                                <td>Admin</td>
                                                            {:else}
                                                                <td>Normal</td>
                                                            {/if}
                                                            <td>{moment(new Date(prop2.joinedAt)).from(new Date())}</td>
                                                            <!-- <td>{JSON.stringify(values[index][index2])}</td> -->
                                                        </tr>
                                                    {/each}
                                                    </tbody>
                                                </table>
                                            </td>
                                        {:else if prop == "clan_ChatHistory"}
                                            <td>ChatHistory</td>
                                            <td>
                                                <!-- create a new table here -->
                                                <table class="table table-bordered table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">username</th>
                                                        <th scope="col">message</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {#each values[index] as prop2, index2}
                                                        {#if prop2.message}
                                                            <tr>
                                                                <!-- <th scope="row">1</th> -->
                                                                <td>{prop2.username}</td>
                                                                <td>{prop2.message}</td>
                                                                <!-- <td>{prop2.joinedAt}</td> -->
                                                                <!-- <td>{JSON.stringify(values[index][index2])}</td> -->
                                                            </tr>
                                                        {/if}
                                                    {/each}
                                                    </tbody>
                                                </table>
                                            </td>
                                        {:else if prop == "activeJoinRequests"}
                                            <td>Join Requests</td>
                                            <td>
                                                <!-- create a new table here -->
                                                <table class="table table-bordered table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">UserId</th>
                                                        <th scope="col">status</th>
                                                        <th scope="col">date</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {#each values[index] as prop2, index2}
                                                        <tr>
                                                            <!-- <th scope="row">1</th> -->
                                                            <td>{prop2.supplicantId}</td>

                                                            {#if prop2.status == 0}
                                                                <td>Accepted</td>
                                                            {:else if prop2.status == 1}
                                                                <td>Rejected</td>
                                                            {:else}
                                                                <td>NotDefined</td>
                                                            {/if}
                                                            <td>{moment(new Date(prop2.date)).from(new Date())}</td>
                                                            <!-- <td>{prop2.joinedAt}</td> -->
                                                            <!-- <td>{JSON.stringify(values[index][index2])}</td> -->
                                                        </tr>
                                                    {/each}
                                                    </tbody>
                                                </table>
                                            </td>
                                        {:else if prop == "weeklyStats" && values[index]}
                                            <td>Weekly Stats</td>
                                            <td>
                                                <!-- create a new table here -->
                                                <table class="table table-bordered table-hover">
                                                    <thead>
                                                    <tr>
                                                        <th scope="col">UserId</th>
                                                        <th scope="col">Stats</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {#each Object.keys(values[index]) as prop2, index2}
                                                        <tr>
                                                            <!-- <th scope="row">1</th> -->
                                                            <td>{prop2}</td>
                                                            <td>{JSON.stringify(Object.values(values[index])[index2])}</td>
                                                            <!-- <td>{prop2.message}</td> -->
                                                            <!-- <td>{prop2.joinedAt}</td> -->
                                                            <!-- <td>{JSON.stringify(values[index][index2])}</td> -->
                                                        </tr>
                                                    {/each}
                                                    </tbody>
                                                </table>
                                            </td>
                                        {:else}
                                            <!-- <th scope="row">1</th> -->
                                            <td>{prop}</td>
                                            <td>{JSON.stringify(values[index])}</td>
                                        {/if}
                                    </tr>
                                {/each}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            {/if}
        </div>
        <div class="tab-pane fade" id="leaderboard" role="tabpanel" aria-labelledby="leaderboard-tab">
<!--            leaderboard-->
            <hr>
            <div class="row justify-content-md-center">
                <div class="card col-md-8">
                    <h5 class="card-header" style="text-align: center;">
                        <h3>Get Best</h3>
                    </h5>

                    <div class="card-body">
                        <div class="mb-3 row">
                            <button
                                    class="btn btn-danger"
                                    type="button"
                                    on:click={GetBestClansOfLastTournament}>Get</button
                            >
                        </div>
                    </div>
                </div>
            </div>

            {#if bestClanIndex.length > 0}
                <hr>

                <div class="row justify-content-md-center">
                    <div class="card col-md-8">
                        <div class="card-header" style="text-align: center;">
                            <h3>Tournament Details</h3>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Item</th>
                                        <th scope="col">Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {#each tournamentDetailsKeys as prop, index}
                                    <tr>
                                        <td>{prop}</td>
                                        <td>{tournamentDetailsValues[index]}</td>
                                    </tr>
                                {/each}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="row justify-content-md-center">
                    <div class="card col-md-8">
                        <div class="card-header" style="text-align: center;">
                            <h3>Best Teams</h3>
                        </div>
                        <div class="card-body">
                            <table class="table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col">Rank</th>
                                        <th scope="col">Team Id</th>
                                        <th scope="col">Team</th>
                                        <th scope="col">Score</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {#each bestClanIndex as prop, index}
                                    <tr>
                                        <td>{prop}</td>
                                        <td>{bestClanIds[index]}</td>
                                        <td>{bestClanNames[index]}</td>
                                        <td>{bestClanScores[index]}</td>
                                    </tr>
                                {/each}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <hr>


                </div>
            {/if}

        </div>

    </div>
</div>

<style>
    .nav-item :not(.active){
        color: black;
    }

    .nav-item .active{
        color: white;
    }

</style>

<svelte:window on:keydown={onKeyDown} />
